import React from 'react';
/**
 * Blue bar with event organizers: Diverxo · COMFAMA · NOVOeia.
 * Shared between the Hero (bottom) and the start of "Conoce todo el evento"
 * (top of ActivitiesSection). Single source of truth — edit logos / labels here.
 */
export function OrganizersBar() {
  return <div className="bg-brand-navy/80 backdrop-blur-md border-t border-white/10 py-4" data-id="element-643">
      <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-12 text-xs sm:text-sm text-white/70 font-medium" data-id="element-644">
        <div className="flex items-center gap-2" data-id="element-645">
          <span data-id="element-646">Organizado por</span>
          <img src="https://cdn.magicpatterns.com/uploads/7j64q3bMK28v58qa96dbdH/logo-Diverxo.svg" alt="Diverxo" className="h-5 sm:h-6 object-contain cursor-pointer hover:opacity-80 transition-opacity" onClick={() => window.dispatchEvent(new CustomEvent('open-diverxo-modal'))} data-id="element-647" />
        </div>
        <div className="hidden sm:block w-1 h-1 rounded-full bg-white/30" data-id="element-648"></div>
        <div className="flex items-center gap-2" data-id="element-649">
          <span data-id="element-650">Apoya</span>
          <img src="https://cdn.magicpatterns.com/uploads/maWeGnwtqNXFiBgbgZj1BW/logo_comfama-Photoroom.png" alt="COMFAMA" className="h-5 sm:h-6 object-contain" data-id="element-651" />
        </div>
        <div className="hidden sm:block w-1 h-1 rounded-full bg-white/30" data-id="element-652"></div>
        <div className="flex items-center gap-2" data-id="element-653">
          <span data-id="element-654">Powered by</span>
          <img src="https://cdn.magicpatterns.com/uploads/1GiADDKPiox3HxhhQyuJik/Logo_Novo3d_trans.png" alt="NOVOeia" className="h-6 sm:h-7 object-contain cursor-pointer hover:opacity-80 transition-opacity" onClick={() => window.dispatchEvent(new CustomEvent('open-novoeia-modal'))} data-id="element-655" />
        </div>
      </div>
    </div>;
}